<div class="widget expanded">
  <!-- Section title -->
  <div class="widget-head">
    <div class="widget-title">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <span class="widget-title-text">{{ '@issuesTitle' | translate }}</span>
      <span class="widget-count">{{ '@issueOpenCount' | translate: { count: openCount } }}</span>
    </div>
    <button type="button" class="fhd-btn report-btn" *ngIf="canReport" data-e2e="report-issue-header"
            (click)="reportIssue()">
      {{ '@issueReportEntry' | translate }}
    </button>
  </div>

  <!-- Body -->
  <div class="widget-body">
    <!-- Loading -->
    <div *ngIf="loading" class="skeletons">
      <div class="skeleton-row" *ngFor="let s of skeletonRows">
        <span class="sk sk-sev"></span><span class="sk sk-title"></span>
        <span class="sk sk-meta"></span><span class="sk sk-conf"></span>
      </div>
    </div>

    <!-- Error -->
    <div *ngIf="!loading && error" class="widget-error">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <div class="widget-error-body">
        <div>{{ '@issueLoadError' | translate }}</div>
        <div class="widget-error-sub" *ngIf="error">{{ error }}</div>
      </div>
      <button type="button" class="text-btn" (click)="retry()">{{ '@issueRetry' | translate }}</button>
    </div>

    <!-- Empty -->
    <div *ngIf="!loading && !error && openCount === 0" class="widget-empty">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
      </svg>
      <div class="widget-empty-title">{{ '@issueNoOpen' | translate }}</div>
      <div class="widget-empty-sub">{{ '@issueNoOpenSub' | translate }}</div>
      <button type="button" class="fhd-btn report-btn" *ngIf="canReport" data-e2e="report-issue-empty"
              (click)="reportIssue()">
        {{ '@issueReportEntry' | translate }}
      </button>
    </div>

    <!-- Flat accordion list (collapsed card ↔ expanded detail in place) -->
    <ng-container *ngIf="!loading && !error && openCount > 0">
      <div class="card-stack">
        <div class="acc-item" *ngFor="let row of shownRows; trackBy: trackByRowId" [@rowLeave]>
          <div *ngIf="isExpanded(row.id)" [@detailExpand] class="acc-detail">
            <app-issue-card-expanded [issueId]="row.id"
                                     [assetId]="assetId"
                                     [assetGroups]="assetGroups"
                                     [seed]="row"
                                     [canMaintain]="canMaintain"
                                     (collapse)="collapseRow()"></app-issue-card-expanded>
          </div>
          <app-issue-row *ngIf="showCollapsed(row.id)"
                         [row]="row"
                         variant="panel"
                         [showCase]="showCase"
                         [writeStatus]="(writeStatusFor(row.id) | async) || WriteStatuses.Idle"
                         (open)="toggleRow($event)"></app-issue-row>
        </div>
      </div>

      <div *ngIf="moreCount > 0" class="more-row">
        {{ '@issueMoreCount' | translate: { count: moreCount } }}
      </div>
    </ng-container>
  </div>
</div>
